module.exports = __webpack_public_path__ + "static/media/shivam.55b869c2.jpeg";